<script>
export default {
  name: 'TaskAcronyms',
  props: ['task', 'date', 'vehicleId', 'throughWaterAcronyms'],
  data () {
    return {
      stoppagesAndChanges: this.task.stoppagesAndChanges.filter(s => s.arrival.split('T')[0] === this.date && !this.throughWaterAcronyms.includes(s.acronym))
    }
  }
}
</script>

<template>
  <div class="text-xs" v-if="stoppagesAndChanges.length && !task.changes.length">
    <span v-show="task.stoppages?.sort((a, b) => new Date(a.arrival) - new Date(b.arrival))[0]?.acronym === stoppagesAndChanges[0].acronym" class="text-info">
      ZAŁ
    </span>
    <span v-for="(stoppageOrChange, i) in stoppagesAndChanges" :key="stoppageOrChange.id">
      <span v-show="stoppagesAndChanges[0].acronym === task.stoppages[0]?.acronym && i === 0 && stoppageOrChange.arrival.split('T')[0] === date">
        {{ stoppageOrChange.arrival.split('T')[1].slice(0, 5) }} {{ stoppageOrChange.acronym }}
        <span v-show="stoppagesAndChanges.length === 2">
          ->
        </span>
        <span v-show="stoppagesAndChanges.length > 2">
          ->
        </span>
      </span>
      <span v-show="stoppagesAndChanges.length > 1 && i > 0 && i < stoppagesAndChanges.length">
        {{ stoppageOrChange.acronym }} {{ stoppageOrChange.arrival.split('T')[1].slice(0, 5) }}
      </span>
      <span v-show="stoppagesAndChanges.length === 1 && stoppagesAndChanges[0].acronym !== task.stoppages[0]?.acronym && i === stoppagesAndChanges.length - 1">
        {{ stoppageOrChange.acronym }} {{ stoppageOrChange.arrival.split('T')[1].slice(0, 5) }}
      </span>
      <span v-show="stoppageOrChange.acronym !== stoppagesAndChanges[0].acronym && stoppageOrChange.acronym !== stoppagesAndChanges.slice(-1)[0].acronym">
        ->
      </span>
    </span>
    <span v-show="task.stoppages?.sort((a, b) => new Date(a.arrival) - new Date(b.arrival))?.slice(-1)[0]?.acronym === stoppagesAndChanges.slice(-1)[0].acronym && stoppagesAndChanges.slice(-1)[0].type !== 1" class="text-danger">
      R
    </span>
  </div>
  <div class="text-xs" v-if="stoppagesAndChanges.length && task.changes.length">
    <span v-show="task.stoppages?.sort((a, b) => new Date(a.arrival) - new Date(b.arrival))[0]?.acronym === task.stoppagesAndChanges.filter(s => s.arrival.split('T')[0] === date)[0]?.acronym && stoppagesAndChanges[0].vehicleId === vehicleId && stoppagesAndChanges[0].arrival.split('T')[0] === date">
      <span class="text-info">ZAŁ</span>
    </span>
    {{ stoppagesAndChanges.map((s, sIdx) => sIdx === (task.stoppagesAndChanges.filter(s => s.vehicleId === vehicleId && s.arrival.split('T')[0] === date).length - 1) && s.acronym === task.stoppages?.sort((a, b) => new Date(a.arrival) - new Date(b.arrival))?.slice(-1)[0].acronym ? s.acronym : `${s.arrival.split('T')[1].slice(0, 5)} ${s.acronym}`).join('->') }}
    <span v-show="task.stoppages?.sort((a, b) => new Date(a.arrival) - new Date(b.arrival))?.slice(-1)[0]?.acronym === stoppagesAndChanges.slice(-1)[0].acronym && stoppagesAndChanges.slice(-1)[0].vehicleId === vehicleId && stoppagesAndChanges.slice(-1)[0].arrival.split('T')[0] === date">
      {{ task.stoppagesAndChanges?.slice(-1)[0]?.arrival?.split('T')[1]?.slice(0, 5) }} <span class="text-danger">R</span>
    </span>
  </div>
</template>

<style scoped>
.text-xs {
  font-size: .6rem;
}
</style>
